module.exports = __webpack_public_path__ + "graphics/01.ckh.783fc62b899f47a6087601b4f280c632.png";